import { certQrCodeApi, certQrCodeByQueryApi } from '../api/certificate'

/**
 * 从后端 ZXing 接口获取二维码（含 queryUrl、qrImageBase64）
 * @param {{ id?: number|string, queryCode?: string, size?: number }} opts
 */
export async function fetchCertQr(opts = {}) {
  const size = opts.size || 280
  let data
  if (opts.id != null && String(opts.id).match(/^\d+$/)) {
    const res = await certQrCodeApi(opts.id, { size })
    data = res.data
  } else if (opts.queryCode) {
    const res = await certQrCodeByQueryApi(opts.queryCode, { size })
    data = res.data
  } else {
    throw new Error('缺少证书 id 或查询码')
  }
  return {
    queryCode: data.queryCode,
    queryUrl: data.queryUrl,
    dataUrl: data.qrImageBase64
  }
}
